module.exports = __webpack_public_path__ + "img/jour.0490b93.svg";